<template>
  <el-card shadow="never">
    <!-- 筛选 -->
    <div style="height: 150px; padding: 10px">
      筛选项
      <el-button
        style="float: right"
        size="mini"
        type="primary"
        @click="addOperator"
        >添加服务商</el-button
      >
    </div>
    <!-- 内容 -->
    <div v-loading="loading">
      <!-- 列表 -->
      <el-table :data="tableData" style="width: 100%">
        <el-table-column prop="" label="logo" width="70">
          <template slot-scope="operator">
            <img
              style="width: 100%"
              v-if="operator.row.operator_avatar"
              :src="operator.row.operator_avatar"
              alt=""
            />
            <img v-else style="width: 100%" :src="defaultLogo" alt="" />
          </template>
        </el-table-column>
        <!-- 服务商  -->
        <el-table-column prop="operator_name" label="服务商名称" width="auto">
          <template slot-scope="operator">
            <div>{{ operator.row.operator_name }}</div>
            <div style="font-size: 10px">
              地址： {{ operator.row.operator_address }}
            </div>
          </template>
        </el-table-column>
        <!--  -->
        <el-table-column prop="dest" label="所在地" width="70%">
          <template slot-scope="operator">
            <div style="text-align: center">
              <el-tag
                effect="plain"
                style="margin-right: 10px"
                size="mini"
                v-for="(item, index) in operator.row.dest_name"
                :key="index"
                >{{ item }}</el-tag
              >
            </div>
          </template>
        </el-table-column>
        <el-table-column
          label-class-name="titel-style-center"
          prop="operator"
          label="操作"
        >
          <template slot-scope="operator">
            <div style="text-align: right">
              <el-link :underline="false" @click="renewOperator(operator.row)"
                >编辑</el-link
              >
              <el-link :underline="false" @click="operatorDetial(operator.row)"
                >|详细</el-link
              >
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </el-card>
</template>

<script>
export default {
  name: "operator-list",
  data() {
    return {
      loading: true,
      tableData: [],
      defaultLogo: "http://szsxtravel.top/traver_default_avatar_user.png",
    };
  },
  mounted() {
    this.$http.get("/product/get_operator_list").then((res) => {
      // console.log(res);
      if (res.data.errno == "0") {
        this.tableData = res.data.data;
        this.loading = false;
      }
    });
  },
  methods: {
    // 添加服务商
    addOperator() {
      this.$router.push({
        name: "operator_add_renew",
      });
    },
    // operator_add_renew
    renewOperator(item) {
      this.$router.push({
        name: "operator_add_renew",
        query: {
          op_id: item.operator_id,
        },
      });
    },
    operatorDetial() {},
    deleteOperator() {
      // 删除一个服务商
    },
  },
};
</script>

<style>
.titel-style-center {
  text-align: right;
}
.gray {
  -webkit-filter: grayscale(100%);
  -moz-filter: grayscale(100%);
  -ms-filter: grayscale(100%);
  -o-filter: grayscale(100%);
  filter: grayscale(100%);
  filter: rgb(204, 204, 204);
}
</style>